let Axios = require('axios')
let mergeWith = require('lodash/mergeWith')
let get = require('lodash/get')
let isArray = require('lodash/isArray')
let forIn = require('lodash/forIn')

let _ = {mergeWith, get, isArray, forIn}

module.exports = {

  /**
   * Fetches compiled config
   *
   * @param {string} env
   * @param {string} documentType
   * @param {string} subType
   * @param {string} productType
   * @returns Promise
   */
  getDocumentConfig(env, documentType, subType, productType) {

    return Axios
      .get(
        ['config',
          env,
          documentType,
          subType,
          productType + '.json'
        ].join('/')
      )
  },

  /**
   * Fetches compiled stylesheet
   *
   * @param {string} env
   * @param {string} type
   * @param {string} subType
   * @returns Promise
   */
  getStyle(env, type, subType) {
    return Axios
      .get(['config', env, type, subType + '.css'].join('/'))
  },

  /**
   * Merges configs and applies some magic (disabling / inheriting fields)
   *
   * @param {Array} defaultBase
   * @param {Array} defaultSpecific
   * @param {Array} environmentBase
   * @param {Array} [environmentBase2]
   * @param {Array} [environmentBase3]
   * @param {Array} [environmentSpecific]
   * @param {Array} [defaultShared]
   * @param {Array} [environmentShared]
   * @returns Object
   */
  mergeDocumentConfigs(defaultBase, environmentBase, environmentBase2, environmentBase3, defaultSpecific, environmentSpecific, defaultShared, environmentShared) {

    let merged = _.mergeWith({}, defaultBase, defaultSpecific, environmentBase, environmentBase2, environmentBase3, environmentSpecific, this.mergeCallback)
    let shared = _.mergeWith(defaultShared, environmentShared, this.mergeCallback())

    _.forIn(merged, (configItem, configItemKey) => {
      // delete and skip shared check if field is disabled
      if (_.get(configItem, 'disabled', false)) {
        delete merged[configItemKey]
        return
      }
      // inherit from shared if specified
      if (_.get(configItem, 'shared', false)) {
        merged[configItemKey] = _.mergeWith(merged[configItemKey], _.get(shared, configItemKey, false), this.mergeCallback())
      }
    })

    return merged
  },

  /**
   *
   * @param {Object} objValue
   * @param {Object} srcValue
   * @returns {*}
   */
  mergeCallback(objValue, srcValue) {
    if (_.isArray(objValue)) {
      return srcValue
    }
  }


  // unused
  //
  // /**
  //  * Saves a config
  //  *
  //  * @param data
  //  * @param type
  //  * @param env
  //  * @returns Promise
  //  */
  // saveConfig(data, type, env) {
  //   return Axios.post(
  //     'api/config',
  //     {
  //       env: env,
  //       type: type,
  //       data: data
  //     }
  //   )
  // },

  // /**
  //  * Fetches uncompiled config
  //  *
  //  * @param environment
  //  * @param type
  //  * @returns Promise
  //  */
  // getRawDocumentConfig(environment, type) {
  //   return Axios
  //     .get('api/config/' + environment + '/' + type)
  // },

  // getConfigList() {
  //   return [
  //     'QTB0',
  //     'QTBC',
  //     'QTD0',
  //     'QTDP',
  //     'QTE0',
  //     'QTEF',
  //     'QTEM',
  //     'QTR0',
  //     'QTRP',
  //     'QTV0',
  //     'QTVC',
  //   ]
  // },
}



// WEBPACK FOOTER //
// ./src/service/ConfigService.js